import { getIdQueryString } from '@quromedical/fhir-common';
import type {
  ExternalUpdateResponse,
  PartialPractitioner,
  PractitionerContactUpdateRequest,
  PractitionerCreateRequest,
  PractitionerGeneralUpdateRequest,
  PractitionerGeneralUpdateResponse,
  PractitionerGetAllResponse,
  PractitionerGetOneResponse,
  PractitionerGetResponse,
  PractitionerSearch,
  PractitionerUpdateStatus,
  QualificationUpdateRequest,
  QualificationUpdateResponse,
  SettingsUpdateResponse,
  UpdatePractitionerExternal,
  UpdatePractitionerSettings,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class PractitionerApi {
  public activate = async (
    params: PractitionerUpdateStatus,
  ): Promise<PartialPractitioner> => {
    return await trpcClient.practitioner.updateStatus.mutate(params);
  };

  public deactivate = async (
    params: PractitionerUpdateStatus,
  ): Promise<PartialPractitioner> => {
    return await trpcClient.practitioner.updateStatus.mutate(params);
  };

  public async getPractitioner(
    practitionerId: string,
  ): Promise<PractitionerGetOneResponse> {
    return await trpcClient.practitioner.getById.query({ id: practitionerId });
  }

  public async getPractitioners(
    params: PractitionerSearch,
  ): Promise<PractitionerGetAllResponse> {
    return await trpcClient.practitioner.getAll.query(params);
  }

  public async getPractitionersByIds(
    id?: (string | undefined)[],
  ): Promise<PractitionerGetAllResponse> {
    const idQuery = getIdQueryString(id);
    if (!idQuery) {
      return {
        practitioners: [],
      };
    }

    return await trpcClient.practitioner.getAll.query({ id: idQuery });
  }

  public async updatePractitionerContact(
    request: PractitionerContactUpdateRequest,
  ): Promise<PractitionerGetOneResponse> {
    const result = await trpcClient.practitioner.updateContact.mutate(request);

    return result;
  }

  public async updatePractitionerGeneral(
    request: PractitionerGeneralUpdateRequest,
  ): Promise<PractitionerGeneralUpdateResponse> {
    const result = await trpcClient.practitioner.updateGeneral.mutate(request);

    return result;
  }

  public async createPractitioner(
    practitioner: PractitionerCreateRequest,
  ): Promise<PractitionerGetResponse> {
    const result = await trpcClient.practitioner.create.mutate(practitioner);
    return result;
  }

  public async updatePractitionerQualification(
    request: QualificationUpdateRequest,
  ): Promise<QualificationUpdateResponse> {
    const result =
      await trpcClient.practitioner.updateQualification.mutate(request);
    return result;
  }

  public async updatePractitionerExternal(
    request: UpdatePractitionerExternal,
  ): Promise<ExternalUpdateResponse> {
    const result = await trpcClient.practitioner.external.mutate(request);
    return result;
  }

  public async updatePractitionerSettings(
    request: UpdatePractitionerSettings,
  ): Promise<SettingsUpdateResponse> {
    const result = await trpcClient.practitioner.settings.mutate(request);
    return result;
  }
}
